import {connect} from 'react-redux';
import React from 'react';

import ConversationSelector from '/app/src/model/Conversation/selector';
import EmployeeSelector from '/app/src/model/Employee/selector';
import EntrySelector from '/app/src/model/Entry/selector';
import PaymentConfigHandler from '/app/src/config/PaymentConfigHandler'

import {Flex} from '/app/src/component'

import ConversationPreview from './PublicConversation'

class PublicContainer extends React.Component {
    render() {
        try {
            let {room, conversation} = this.props
            let entry = ConversationSelector.lastEntry(conversation)
            let currentRoom = this.props.currentRoom
            const featurePermission = PaymentConfigHandler.checkAccess('groupChat', 'admin')
            let groupChannelBtn = null;
            if (featurePermission === 'unlimited') {
                groupChannelBtn = (
                    <ConversationPreview
                        room={room}
                        currentRoom={currentRoom}
                        title='Gruppkanal'
                        isOnline={false}
                        entry={entry}
                        employeeName={this.props.employeeName}
                        unread={this.props.unread}
                        isTyping={false}/>
                    )
            } else {
                groupChannelBtn = (
                    <Flex w='100%' h='100%' onClick={ () => this.setState({showModal: true})}>
                        <ConversationPreview
                            title='Gruppkanal'/>
                    </Flex>
                )
            }
            return <Flex w='100%'>
                    {groupChannelBtn}
                </Flex>
        }
        catch(err){
            return null;
        }
        }
}

function mapStateToProps(state, ownProps){
    let userId = state.getIn(['user', 'login', 'id'])
    let conversation = ConversationSelector.getByRoom(state, ownProps.room)

    let entry = ConversationSelector.lastEntry(conversation)

    let entryCreatorId = EntrySelector.creatorId(entry)
    let employee = EmployeeSelector.getById(state, entryCreatorId)
    let employeeName = EmployeeSelector.getName(employee)

    let unread = ConversationSelector.getUnread(conversation, userId)
    return {
        conversation, unread, entry, entryCreatorId, employee, employeeName
    }
}

export default connect(mapStateToProps)(PublicContainer);



// WEBPACK FOOTER //
// ./src/component/Conversation/Preview/PublicContainer.js